import axios, {AxiosResponse} from "axios";
import environment from "../config";
import axiosUtil from "../utils/helpers/axiosUtil";


export async function GetTofesZikna(
    fundCode: string | null | undefined,
) {
        try {
            const body = {
                tokenNum: sessionStorage.getItem("token"),
                fundCode: fundCode,
            };
            const path = environment.BASE_URL + "MemberDetails/GetRetiredPensionFormPath";
            const res: AxiosResponse<any> = await axios.post(path, body);
            if (res?.status === 200 && res?.data?.errorCode === 0) return res?.data.formUrl;
            // handle max server case

            return false;
        } catch (err) {
            console.log(err);
        }
    
    return false;
}